import script from "./SectionAboutBeplanet.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionAboutBeplanet.vue?vue&type=script&setup=true&lang=js"

import "./SectionAboutBeplanet.vue?vue&type=style&index=0&id=d254fc44&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d254fc44"]])

export default __exports__